export default "__VITE_ASSET__mNFeC7ZZ__"